"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
let BatteryBar = class BatteryBar extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.heightBar = 0;
        this.colorManager = new ColorLibController_1.default();
    }
    mounted() {
        this.resetHeight();
    }
    resetHeight() {
        this.heightBar = this.gap * 100;
    }
    calculateCategory(score) {
        return this.colorManager.getCategoryFromScore(score);
    }
    calculateCSSClasses(category) {
        return this.colorManager.getCSSClassesForCategory(category);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], BatteryBar.prototype, "height", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], BatteryBar.prototype, "current", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: -1 })
], BatteryBar.prototype, "position", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: -1 })
], BatteryBar.prototype, "gap", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('height')
], BatteryBar.prototype, "resetHeight", null);
BatteryBar = __decorate([
    (0, vue_property_decorator_1.Options)({})
], BatteryBar);
exports.default = BatteryBar;
